import get from 'lodash/get';
import createConsts from '../../utils/redux/consts';
import createActions from '../../utils/redux/actions';
import * as unresolvedList from './complaintUnResolvedList';
import * as resolvedList from './complaintResolvedList';
import chatConsts from '../chatConnection/constants';

export const consts = createConsts(
  'complaints',
  'counters',
  'UPDATE_UNRESOLVED',
);
export const actions = createActions(consts);

const initialState = {
  unresolved: 0,
  resolved: 0,
};

export default function complaintCounters(state = initialState, action) {
  switch (action.type) {
    case unresolvedList.paginationConsts.ADD_META:
    case resolvedList.paginationConsts.ADD_META:
    case unresolvedList.consts.ADD_META:
    case resolvedList.consts.ADD_META: {
      const unresolved = get(action.payload, 'unresolvedComplaintsCount', 0);
      const resolved = get(action.payload, 'resolvedComplaintsCount', 0);

      return {
        ...state,
        unresolved,
        resolved,
      };
    }

    case chatConsts.NEW_COMPLAINT: {
      return {
        ...state,
        unresolved: state.unresolved + 1,
      };
    }

    case consts.UPDATE_UNRESOLVED: {
      return {
        ...state,
        unresolved: state.unresolved - 1,
      };
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/complaints/complaintCounters.js